import { render } from "./MeuPerfil.vue?vue&type=template&id=3a884655"
import script from "./MeuPerfil.vue?vue&type=script&lang=js"
export * from "./MeuPerfil.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__